import { module } from 'modujs';
import gsap from 'gsap';

export default class extends module {
  constructor(m) {
    super(m);
    this.events = {
      change: {
        trigger: 'capture',
      },
    };
  }

  capture() {
    this.$('receptor')[0].innerHTML =
      this.$('trigger')[0].options[this.$('trigger')[0].selectedIndex].text;
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    gsap.delayedCall(0.1, () => {
      this.capture();
    });
  }
}
